<template>
  <div class="CourseCount">
    <div class="container-fluid background-color">
      <div class="row vertical-align height-150px">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 font-color font-size-60px">
              &nbsp;{{ selectedCourseCountVal }}
            </div>
          </div>
          <div class="row">
            <!-- <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h4>{{getStringToDisplay}}</h4>
            </div> -->
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 tooltip1 font-size-16px padding-left-0Perc padding-right-0Perc cursor-pointer">
              <i class="col-xs-2 col-xs-offset-3 col-sm-10 col-sm-offset-2 col-md-4 col-md-offset-1 col-lg-2 col-lg-offset-3 glyphicon glyphicon-info-sign margin-top-10px margin-bottom-10px padding-left-0Perc padding-right-0Perc"><span class="tooltiptext1 CourseCount">No. of courses</span></i>
            <!-- </div> -->
            <!-- <div class="col-xs-9 col-sm-12 col-md-8 col-lg-9 text-align-left padding-right-0Perc"> -->
              <h4 class="col-xs-7 col-xs-offset-0 col-sm-9 col-sm-offset-3 col-md-7 col-md-offset-0 col-lg-7 col-lg-offset-0 padding-left-0Perc padding-right-0Perc text-align-left">{{selectedCourseCountVal > 1 ? 'COURSES' : 'COURSE'}}</h4>
            </div>
          
          </div>
        </div>
      </div>
    </div>  
  </div>
</template>

<script>
import filter from 'lodash/filter'
export default {
  beforeDestroy () {},
  created: function () {},
  data: function () {
    return {
      selectedCourseCount: 0
    }
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.selectedGroupCourses
      }
    },
    selectedCourseCountVal: {
      get: function () {
        return this.selectedCourseCount
      }
    }
  },
  methods: {
    calculateCourseCountValue: function () {
      this.selectedCourseCount = filter(this.getGroupCourseList, (obj) => {
        return obj.isSelected === true
      }).length
    }
  },
  watch: {
    getGroupCourseList: function (newVal, oldVal) {
      this.calculateCourseCountValue()
    }
  },
  name: 'CourseCount'
}
</script>
<style>
.color-red{
  border: 1px solid red;
}
.height-65px{
 height: 65px;
}
.height-150px{
 height: 175px;
}
.width-170px{
  width: 170px;
}
.border-1px{
    border: 1px solid #ccc;
}
.float-left{
  float: left;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.background-color{
  background-color:#fafafa;
}
.font-color{
  color:#27345B !important;
}
.font-size-60px{
  font-size: 60px;
}

.tooltip1 {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; */
}
.tooltip1 .tooltiptext1 {
    visibility: hidden;
    width: 100px;
    background-color: #696969;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    position: absolute;
    z-index: 1;
    top: 150%;
    left: 50%;
    margin-left: -50px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    font-size: 12px;
}
.tooltip1 .tooltiptext1::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent #696969 transparent;
}
.tooltip1 :hover .tooltiptext1 {
    visibility: visible;
}
.margin-top-10px{
  margin-top: 10px;
}
.margin-bottom-10px{
  margin-bottom: 10px;
}
.padding-left-0Perc{
  padding-left:0%;
}
 .padding-right-0Perc{
  padding-right:0%;
}
h4{
 font-family: inherit;
 font-weight: 500;
 line-height: 1.1;
 color:inherit; 
 font-size:1em;
}
.text-align-left{
  text-align: left;
}
.cursor-pointer{
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard_v2/CourseCount.vue